/**
 * Server-side feature flags resolved at build time from environment variables.
 *
 * VITE_GENERAL_SHAPES_ENABLED:
 *   - Omit or set to 'true'  → server allows (users may toggle in Settings)
 *   - Set to 'false'         → server disables (setting hidden, always off)
 */
export const GENERAL_SHAPES_SERVER_ENABLED: boolean =
  import.meta.env.VITE_GENERAL_SHAPES_ENABLED !== 'false';
